var React = require('react');

function FacebookB (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 1H9C7.67392 1 6.40215 1.52678 5.46447 2.46447C4.52678 3.40215 4 4.67392 4 6V9H1V13H4V21H8V13H11L12 9H8V6C8 5.73478 8.10536 5.48043 8.29289 5.29289C8.48043 5.10536 8.73478 5 9 5H12V1Z","stroke":"#1E3774","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

FacebookB.defaultProps = {"width":"13","height":"22","viewBox":"0 0 13 22","fill":"none"};

module.exports = FacebookB;

FacebookB.default = FacebookB;
